"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Wrapper = styled_components_1.default.div `
  border-radius: 32px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, type }) => {
    if (type === "success")
        return theme.success.main;
    if (type === "warning")
        return theme.warning.main;
    if (type === "error")
        return theme.error.main;
    return theme.primary.main;
}};
  color: ${({ theme }) => theme.white};
`;
const RotaBadge = (_a) => {
    var { children, type = "primary" } = _a, props = __rest(_a, ["children", "type"]);
    return (react_1.default.createElement(Wrapper, Object.assign({ type: type }, props), children));
};
exports.default = RotaBadge;
